import { PresetChartType, CreateChartTypeName } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import i18n from 'i18next';
import { ChartGroupKey } from '../../config';
import { mappingSlideChartTypeToSTChartType } from '../../utils';

export const CHART_TYPE_CONFIG_FOR_SELECTOR: any[] = [
    {
        group: ChartGroupKey.Column,
        groupName: i18n.t('柱状图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.COLUMN_CLUSTERED),
                name: CreateChartTypeName[PresetChartType.COLUMN_CLUSTERED],
                icon: 'column_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.COLUMN_STACKED),
                name: CreateChartTypeName[PresetChartType.COLUMN_STACKED],
                icon: 'column_stack_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.COLUMN_PERCENT_STACKED),
                name: CreateChartTypeName[PresetChartType.COLUMN_PERCENT_STACKED],
                icon: 'column_stack_percent_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Bar,
        groupName: i18n.t('条形图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.BAR_CLUSTERED),
                name: CreateChartTypeName[PresetChartType.BAR_CLUSTERED],
                icon: 'bar_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.BAR_STACKED),
                name: CreateChartTypeName[PresetChartType.BAR_STACKED],
                icon: 'bar_stack_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.BAR_PERCENT_STACKED),
                name: CreateChartTypeName[PresetChartType.BAR_PERCENT_STACKED],
                icon: 'bar_stack_percent_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Line,
        groupName: i18n.t('折线图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_STANDARD),
                name: CreateChartTypeName[PresetChartType.LINE_STANDARD],
                icon: 'line_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_STACKED),
                name: CreateChartTypeName[PresetChartType.LINE_STACKED],
                icon: 'stacked_line_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_PERCENT_STACKED),
                name: CreateChartTypeName[PresetChartType.LINE_PERCENT_STACKED],
                icon: 'percent_stacked_line_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_STANDARD_WITH_POINT),
                name: CreateChartTypeName[PresetChartType.LINE_STANDARD_WITH_POINT],
                icon: 'marked_line_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_STACKED_WITH_POINT),
                name: CreateChartTypeName[PresetChartType.LINE_STACKED_WITH_POINT],
                icon: 'marked_stacked_line_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.LINE_PERCENT_STACKED_WITH_POINT),
                name: CreateChartTypeName[PresetChartType.LINE_PERCENT_STACKED_WITH_POINT],
                icon: 'marked_percent_stacked_line_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Pie,
        groupName: i18n.t('饼图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.PIE),
                name: CreateChartTypeName[PresetChartType.PIE],
                icon: 'pie_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.OF_PIE),
                name: CreateChartTypeName[PresetChartType.OF_PIE],
                icon: 'pie_of_pie_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.OF_PIE_BAR),
                name: CreateChartTypeName[PresetChartType.OF_PIE_BAR],
                icon: 'bar_of_pie_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.DOUGHNUT),
                name: CreateChartTypeName[PresetChartType.DOUGHNUT],
                icon: 'doughnut_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Area,
        groupName: i18n.t('面积图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.AREA),
                name: CreateChartTypeName[PresetChartType.AREA],
                icon: 'area_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.AREA_STACKED),
                name: CreateChartTypeName[PresetChartType.AREA_STACKED],
                icon: 'area_stack_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.AREA_PERCENT_STACKED),
                name: CreateChartTypeName[PresetChartType.AREA_PERCENT_STACKED],
                icon: 'area_stack_percent_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Radar,
        groupName: i18n.t('雷达图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.RADAR),
                name: CreateChartTypeName[PresetChartType.RADAR],
                icon: 'radar_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.RADAR_WITH_POINT),
                name: CreateChartTypeName[PresetChartType.RADAR_WITH_POINT],
                icon: 'radar_with_markers_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.RADAR_WITH_FILL),
                name: CreateChartTypeName[PresetChartType.RADAR_WITH_FILL],
                icon: 'filled_radar_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Scatter,
        groupName: i18n.t('散点图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.SCATTER),
                name: CreateChartTypeName[PresetChartType.SCATTER],
                icon: 'scatter_icon',
            },
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.BUBBLE),
                name: CreateChartTypeName[PresetChartType.BUBBLE],
                icon: 'bubble_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Stock,
        groupName: i18n.t('股价图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.STOCK),
                name: CreateChartTypeName[PresetChartType.STOCK],
                icon: 'stock_high_low_close_icon',
            },
        ],
    },
    {
        group: ChartGroupKey.Combo,
        groupName: i18n.t('组合图'),
        items: [
            {
                type: mappingSlideChartTypeToSTChartType(PresetChartType.COMBO),
                name: CreateChartTypeName[PresetChartType.COMBO],
                icon: 'combo_icon',
            },
        ],
    },
];
